/**
 * Env config — production truth for this repo:
 * - `react-scripts` (CRA) injects only `process.env.REACT_APP_*` at build time.
 * - `VITE_*` keys are not substituted by CRA; keep them in Vercel/.env.production only for parity / future Vite migration.
 * The second argument is the CRA key actually read here (`craKey || viteKey`).
 */
function getEnv(viteKey, craKey) {
  const key = craKey || viteKey;
  return typeof process !== "undefined" && process.env ? process.env[key] : undefined;
}

export const API_URL = getEnv("VITE_API_URL", "REACT_APP_API_URL");
export const USE_REAL_API = getEnv("VITE_USE_REAL_API", "REACT_APP_USE_REAL_API");
export const SITE_URL = getEnv("VITE_SITE_URL", "REACT_APP_SITE_URL");

/** Canonical support email — override via REACT_APP_SUPPORT_EMAIL if needed. */
export const SUPPORT_EMAIL =
  getEnv("VITE_SUPPORT_EMAIL", "REACT_APP_SUPPORT_EMAIL") || "support@prombiz.co.il";
